import hotKeyMappings from '../utils/hotKeyMappings';
import universalMap from '../utils/universalMapping';

const fetchShortcut = (label, _key) => {
  const val = universalMap.filter((eachMap) => eachMap.mode_name === _key);
  const val2 = hotKeyMappings.filter((eachMap) => eachMap.mapping === _key);
  if (val.length > 0) {
    return `${label} (${val[0].hotKey})`;
  }
  if (val2.length > 0) {
    return `${label} (${val2[0].key})`;
  }
  return label;
};

export default fetchShortcut;
